import { gql } from '@apollo/client'

export const SEND_OTP = gql`
  mutation sendOtp($email: String!) {
    sendOtp(email: $email) {
      msg
      success
    }
  }
`
export const SIGN_UP = gql`
  mutation signUp(
    $firstname: String
    $lastname: String
    $email: String
    $password: String!
    $phone: String
    $homeCountry: String
    $currentCountry: locationInput
    $otp: String
  ) {
    signUp(
      firstname: $firstname
      lastname: $lastname
      email: $email
      password: $password
      phone: $phone
      homeCountry: $homeCountry
      currentCountry: $currentCountry
      otp: $otp
    ) {
      access_token
      msg
      success
      user {
        firstname
        lastname
      }
    }
  }
`
export const SEEN_ONBOARD = gql`
  mutation seenOnBoard {
    seenOnBoard {
      msg
      success
    }
  }
`
export const ADD_EDUCATION = gql`
  mutation addEducationDetails(
    $school_id: String!
    $schoolName: String!
    $endYear: String
    $course: String
  ) {
    addEducationDetails(
      school_id: $school_id
      schoolName: $schoolName
      endYear: $endYear
      course: $course
    ) {
      msg
      success
    }
  }
`
export const SCHOOL_SEARCH = gql`
  query schoolSearch($byName: String, $byCountry: String, $requestedPage: Int) {
    schoolSearch(
      byName: $byName
      byCountry: $byCountry
      requestedPage: $requestedPage
    ) {
      School {
        id
        state_province
        country
        location {
          locationName
          lat
          lng
        }
        domains
        name
      }
      current_page
      last_page
    }
  }
`

export const GET_SERVICE_TYPES = gql`
  query getServiceCategory {
    getServiceCategory {
      id
      serviceCategory
      required_kyc
      approved
    }
  }
`
export const PLACE_SEARCH = gql`
  query placeSearch($place: String!) {
    placeSearch(place: $place) {
      success
      msg
      predictions {
        description
        place_id
      }
    }
  }
`
export const PLACE_DETAIL = gql`
  query placeDetails($place_id: String!) {
    placeDetail(place_id: $place_id) {
      success
      msg
      geometry {
        location {
          lat
          lng
        }
      }
    }
  }
`
export const ADD_SERVICE = gql`
  mutation createService(
    $name: String
    $serviceType_id: Int
    $location: [locationInput]
    $email: String
    $mobile: String
    $details: String
  ) {
    createService(
      name: $name
      serviceType_id: $serviceType_id
      location: $location
      email: $email
      mobile: $mobile
      details: $details
    ) {
      msg
      success
    }
  }
`
export const LOGIN = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      access_token
      msg
      success
      user {
        firstname
        lastname
        seenOnBoard
        defaultDestination
      }
    }
  }
`

export const UPDATE_DEFAULT_DESTINATION = gql`
  mutation updateDefaultDestination($country: String!) {
    updateDefaultDestination(country: $country) {
      msg
      success
    }
  }
`
export const FETCH_USER = gql`
  query user {
    user {
      firstname
      lastname
    }
  }
`
export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email) {
      msg
      success
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation resetPassword(
    $email: String
    $resetToken: String
    $newPassword: String!
  ) {
    resetPassword(
      email: $email
      resetToken: $resetToken
      newPassword: $newPassword
    ) {
      msg
      success
    }
  }
`
export const UPDATE_CURRENT_COUNTRY = gql`
  mutation updateCurrentCountry($location: locationInput) {
    updateCurrentCountry(location: $location) {
      msg
      success
    }
  }
`

export const UPDATE_PICTURE = gql`
  mutation updatePicture($picture: Upload!) {
    updatePicture(picture: $picture) {
      msg
      success
    }
  }
`
export const GET_EDUCATION = gql`
  query {
    getUserEducationRecords {
      schoolName
      id
      # school_id: String
      course
      startYear
      endYear
    }
  }
`
export const GET_SERVICES = gql`
  query {
    myService {
      id
      name
      serviceType_id
      location {
        locationName
      }
      details
      email
      mobile
      isDisabled
      countries
      cities
    }
    cf
  }
`
export const GET_AUTH_USER = gql`
  query {
    getAuthUser {
      id
      firstname
      lastname
      email
      phone
      photolink
      IsAdmin
      usertags
      IsSuperAdmin
      homeCountry
      location {
        locationName
      }
      currentCountry {
        country
        lat
        lng
      }
      defaultDestination
      seenOnBoard
      usertags
      # }
    }
  }
`

export const USER_WITH_SAME_SCHOOL = gql`
  query getUsersWithSameSchool($schoolName: String, $school_id: Int) {
    getUsersWithSameSchool(schoolName: $schoolName, school_id: $school_id) {
      id
      firstname
      lastname
      email
      phone
      IsAdmin
      IsSuperAdmin
      homeCountry
      location {
        locationName
      }
      currentCountry {
        country
      }
      defaultDestination
      seenOnBoard
    }
  }
`

export const JOIN_VOICE_CHAT = gql`
  mutation JoinVoiceChat($chatId: Int, $room_password: String) {
    joinVoiceChat(chatId: $chatId, room_password: $room_password) {
      msg
      access_token
      success
      VoiceChat {
        id
      }
    }
  }
`

export const GET_USER = gql`
  query user($id: ID) {
    user(id: $id) {
      firstname
      lastname
    }
  }
`

export const SEND_MESSAGE = gql`
  mutation sendMessage($chatroom_id: Int, $message: String) {
    sendMessage(chatroom_id: $chatroom_id, msg: $message) {
      msg
      success
      message {
        id
        chatroom_id
        user_id
        message
        read_at
      }
    }
  }
`

export const GET_REQUESTLIST = gql`
  query getMyChatRequest($requestedPage: Int, $itemsPerPage: Int) {
    getMyChatRequest(
      requestedPage: $requestedPage
      itemsPerPage: $itemsPerPage
    ) {
      chatRequest {
        id
        created_by
        message
        participant
        status
        createdByMe
        user {
          id
          firstname
          lastname
          email
          phone
          IsAdmin
          IsSuperAdmin
          homeCountry
          location {
            locationName
          }
          currentCountry {
            lat
            lng
            country
            city
          }
          defaultDestination
          photolink
          canRequestToChat
        }
      }
      current_page
      last_page
    }
  }
`

export const MEET_PEOPLE = gql`
  query meetPeople($byCountry: String, $byCity: String, $requestedPage: Int) {
    meetPeople(
      byCountry: $byCountry
      byCity: $byCity
      requestedPage: $requestedPage
    ) {
      User {
        id
        firstname
        lastname
        email
        phone
        canRequestToChat
        photolink
        # currentCountry
        homeCountry
        location {
          locationName
          lat
          lng
        }
        currentCountry {
          lat
          lng
          country
          city
        }
        defaultDestination
        # seenOnBoard
      }
      current_page
      last_page
    }
  }
`

export const SERVICES_SEARCH = gql`
  query getServices(
    $byCountry: String
    $byServiceCategory: Int
    $byName: String
    $byCity: String
    $requestedPage: Int
  ) {
    getServices(
      byCountry: $byCountry
      byServiceCategory: $byServiceCategory
      byName: $byName
      byCity: $byCity
      requestedPage: $requestedPage
    ) {
      Service {
        id
        user_id
        owner {
          id
          firstname
          lastname
          email
          phone
          canRequestToChat
          requestToChatStatus
        }
        name
        serviceType_id
        location {
          locationName
          lat
          lng
        }
        details
        email
        mobile
        approved
        ratings {
          rating
        }
        countries
        cities
      }
      last_page
    }
  }
`

export const GET_VOICE_CHATS = gql`
  query getVoiceChats(
    $byCountry: String
    $byCity: String
    $byCategory: Int
    $requestedPage: Int
  ) {
    getVoiceChats(
      byCountry: $byCountry
      byCity: $byCity
      byCategory: $byCategory
      requestedPage: $requestedPage
    ) {
      VoiceChat {
        id
        title
        category
        country
        city
        channel_type
        speakers
        moderators
        host {
          firstname
          photolink
          lastname
        }
        schedule_time
      }
      last_page
    }
  }
`

export const DELETE_SCHOOL_DETAILS = gql`
  mutation deleteEducationDetail($id: Int!) {
    deleteEducationDetail(id: $id) {
      msg
      success
    }
  }
`

export const DISABLE_SERVICE = gql`
  mutation disableService($id: Int!) {
    disableService(id: $id) {
      msg
      success
    }
  }
`
export const DELETE_SERVICE = gql`
  mutation deleteService($id: Int!) {
    deleteService(id: $id) {
      msg
      success
    }
  }
`
export const UPDATE_SERVICE = gql`
  mutation updateService(
    $id: Int
    $details: String
    $email: String
    $mobile: String
  ) {
    updateService(id: $id, details: $details, email: $email, mobile: $mobile) {
      msg
      success
    }
  }
`
export const CREATE_ACCOMODATION = gql`
  mutation createAccommodation(
    $type: String
    $description: String
    $total_bedroom: Int
    $bedroom_type: [String]
    $total_bathroom: Int
    $total_kitchen: Int
    $address: accommodationAddressInput
    $price: accommodationPriceInput
    $property_size: Int
    $furnishings: [String]
    $amenities: [String]
  ) {
    createAccommodation(
      type: $type
      description: $description
      total_bedroom: $total_bedroom
      bedroom_type: $bedroom_type
      total_bathroom: $total_bathroom
      total_kitchen: $total_kitchen
      address: $address
      price: $price
      property_size: $property_size
      furnishings: $furnishings
      amenities: $amenities
    ) {
      msg
      success
      accommodation {
        id
      }
    }
  }
`
export const ADD_ACCOMMODATION_IMAGE = gql`
  mutation addImagesToListings($accommodationId: Int, $files: [Upload]) {
    addImagesToListings(accommodationId: $accommodationId, files: $files) {
      msg
      success
    }
  }
`

export const GET_VOICE_CHAT_DETAIL = gql`
  query getVoiceChatDetails($byId: Int) {
    getVoiceChatDetails(byId: $byId) {
      id
      title
      category
      country
      city
      channel_type
      host {
        firstname
        photolink
        lastname
      }
      # speakers
      # moderators
      # host{

      # }
      # schedule_time
    }
  }
`
export const LIST_AMENITIES = gql`
  query getAmenitiesList {
    getAmenitiesList
  }
`

export const MY_CHATS = gql`
  query MyChats {
    MyChats {
      id
      name
      participant
      type
      channel_type
      category
      user {
        id
        firstname
        lastname
        email
        phone
        photolink
        # currentCountry
        homeCountry
        location {
          locationName
          lat
          lng
        }
        currentCountry {
          lat
          lng
          country
          city
        }
        defaultDestination
        # seenOnBoard
      }
      last_message {
        id
        chatroom_id
        user_id
        message
        read_at
        created_at
      }
    }
  }
`
export const GET_CHAT_ROOM_MESSAGES = gql`
  query getChatRoomMessages($chatroom_id: Int) {
    getChatRoomMessages(chatroom_id: $chatroom_id) {
      id
      chatroom_id
      user_id
      message
      read_at
      created_at
    }
  }
`

export const LIST_FURNISHING = gql`
  query getFurnishings {
    getFurnishings
  }
`
export const VIEW_ACCOMODATION = gql`
  query filterAccommodations(
    $byCountry: String
    $byListingType: String
    $requestedPage: Int # $byCity: String
    $byMinPrice: String
    $byArea: String
    $byMaxPrice: String
    $byTotalBedRoom: Int
  ) {
    filterAccommodations(
      byCountry: $byCountry
      requestedPage: $requestedPage
      byListingType: $byListingType
      byMinPrice: $byMinPrice
      byArea: $byArea
      byMaxPrice: $byMaxPrice
      byTotalBedRoom: $byTotalBedRoom
    ) {
      listing {
        rental_prices {
          per_week
          per_month
          accurate
        }
        num_floors
        listing_status
        num_bedrooms
        furnished_state
        agent_address
        agnet_name
        agent_logo
        agent_phone
        country
        category
        property_type
        short_description
        description
        listing_id
        status
        displayable_address
        num_bathrooms
        post_town
        currency
        images
        latitude
        longitude
        letting_fees
      }
      status
      msg
      current_page
      last_page
    }
  }
`

export const GOOGLE_AUTH = gql`
  mutation googleAuth(
    $token: String
    $password: String
    $phone: String
    $homeCountry: String
  ) {
    googleAuth(
      token: $token
      password: $password
      phone: $phone
      homeCountry: $homeCountry
    ) {
      access_token
      msg
      success
      user {
        firstname
        lastname
        seenOnBoard
        defaultDestination
      }
    }
  }
`

export const CHECK_GOOGLE_AUTH = gql`
  mutation verifyUserViaGoogleToken($token: String) {
    verifyUserViaGoogleToken(token: $token) {
      access_token
      msg
      success
      user {
        firstname
        lastname
        seenOnBoard
        defaultDestination
      }
    }
  }
`
export const ACCEPT_REQUEST = gql`
  mutation acceptChatRequest($request_id: Int) {
    acceptChatRequest(request_id: $request_id) {
      msg
      statusCode
      success
    }
  }
`
export const DENY_REQUEST = gql`
  mutation denyChatRequest($request_id: Int) {
    denyChatRequest(request_id: $request_id) {
      msg
      statusCode
      success
    }
  }
`
export const REQUEST_TO_CHAT = gql`
  mutation requestToChatWithUser($user_id: Int, $msg: String) {
    requestToChatWithUser(user_id: $user_id, msg: $msg) {
      msg
      statusCode
      success
    }
  }
`
export const CREATE_CHAT_ROOM = gql`
  mutation createChatRoom(
    $name: String
    $channel_type: String
    $category: Int
    $password: String
  ) {
    createChatRoom(
      name: $name
      channel_type: $channel_type
      category: $category
      password: $pssword
    ) {
      msg
      statusCode
      success
    }
  }
`

export const RATE_SERVICE = gql`
  mutation rateService($rating: Int, $service_id: Int) {
    rateService(rating: $rating, service_id: $service_id) {
      msg
      statusCode
      success
    }
  }
`
export const MAKE_COMMENT = gql`
  mutation makeComment($service_id: Int, $comment: String) {
    makeComment(service_id: $service_id, comment: $comment) {
      msg
      statusCode
      success
    }
  }
`

export const REPLY_COMMENT = gql`
  mutation replyComment($comment_id: Int, $reply: String) {
    replyComment(comment_id: $comment_id, reply: $reply) {
      msg
      statusCode
      success
    }
  }
`

export const GET_SERVICES_COMMENTS = gql`
  query getServiceComments($service_id: Int, $itemsPerPage: Int) {
    getServiceComments(service_id: $service_id, itemsPerPage: $itemsPerPage) {
      comments {
        id
        comment
        created_at
        updated_at
        user_id
        replies {
          id
          comment_id
          user_id
          reply
          created_at
          user {
            photolink
            firstname
            lastname
          }
        }
        user {
          photolink
          firstname
          lastname
        }
      }
    }
  }
`

export const CREATE_VOICE_CHAT = gql`
  mutation createVoiceChat(
    $title: String
    $category: Int
    $country: String
    $city: String
    $description: String
    $channel_type: Boolean
    $room_password: String
    $speakers: [Int]
    $moderators: [Int]
    $schedule_time: DateTime
  ) {
    createVoiceChat(
      title: $title
      category: $category
      country: $country
      city: $city
      description: $description
      channel_type: $channel_type
      room_password: $room_password
      speakers: $speakers
      moderators: $moderators
      schedule_time: $schedule_time
    ) {
      msg
      success
    }
  }
`

export const FETCH_MY_QUESTIONS = gql`
  query myQuestions($requestedPage: Int, $itemsPerPage: Int) {
    myQuestions(requestedPage: $requestedPage, itemsPerPage: $itemsPerPage) {
      questions {
        id
        title
        description
        tags
        user_id
        totalvalidanswers
        created_at
        user {
          id
          firstname
          lastname
          email
          photolink
          usertags
        }
        answers {
          id
          question_id
          user_id
          user {
            id
            firstname
            lastname
            email
            photolink
            usertags
          }
        }
      }

      status
      msg
      current_page
      last_page
    }
  }
`
export const FETCH_SEARCH_QUESTIONS = gql`
  query searchQuestions(
    $byTags: [String]
    $byTitle: String
    $byDescription: String
    $requestedPage: Int
    $itemsPerPage: Int
  ) {
    searchQuestions(
      byTags: $byTags
      byTitle: $byTitle
      byDescription: $byDescription
      requestedPage: $requestedPage
      itemsPerPage: $itemsPerPage
    ) {
      questions {
        id
        title
        description
        tags
        user_id
        totalvalidanswers
        created_at
        user {
          id
          firstname
          lastname
          email
          photolink
          usertags
        }
        answers {
          id
          question_id
          user_id
          user {
            id
            firstname
            lastname
            email
            photolink
            usertags
          }
        }
      }

      status
      msg
      current_page
      last_page
    }
  }
`

export const FETCH_SINGLE_QUESTION = gql`
  query getQuestionById($question_id: Int) {
    getQuestionById(question_id: $question_id) {
      question {
        id
        title
        description
        tags
        user_id
        totalvalidanswers
        duplicate_of
        created_at
        user {
          id
          firstname
          lastname
          email
          photolink
          usertags
        }
        answers {
          id
          answer
          created_at
          rating
          comments {
            created_at
            comment

            user {
              id
              firstname
              lastname
              email
              photolink
              usertags
            }
          }
          user {
            id
            firstname
            lastname
            email
            photolink
            usertags
          }
        }
      }
      success
      msg
    }
  }
`

export const ANSWER_QUESTION = gql`
  mutation answerQuestion($question_id: Int, $answer: String) {
    answerQuestion(question_id: $question_id, answer: $answer) {
      msg
      success
    }
  }
`

export const ASK_QUESTION = gql`
  mutation askQuestion($title: String, $description: String, $tags: [String]) {
    askQuestion(title: $title, description: $description, tags: $tags) {
      msg
      success
    }
  }
`
export const REPLY_ANSWER = gql`
  mutation commentOnAnswer($answer_id: Int, $answer: String) {
    commentOnAnswer(answer_id: $answer_id, comment: $answer) {
      msg
      success
    }
  }
`

export const RATE_ANSWER = gql`
  mutation rateAnswer($answer_id: Int, $rating: Int) {
    rateAnswer(answer_id: $answer_id, rating: $rating) {
      msg
      success
    }
  }
`
export const UPDATE_PREFERENCE = gql`
  mutation updateUserPreferences($tags: [String]) {
    updateUserPreferences(tags: $tags) {
      msg
      success
    }
  }
`
export const FETCH_TAGS = gql`
  query allTagsAvailable {
    allTagsAvailable
  }
`
// export const GET_CHATROOM_CATEGORY = gql`
// `
